import React, {useEffect, useRef, useState} from 'react';
import {NavLink} from 'react-router-dom';
import PropTypes from 'prop-types';

import {discoverUrl} from '../../../util/url';

import './DiscoverCategoryFilter.css';

/**
 * 디스커버 - 카테고리 필터
 * @param categories
 * @param selectedCategory
 * @param discoverTab
 * @returns {JSX.Element|null}
 * @constructor
 */
export default function DiscoverCategoryFilter({categories, selectedCategory, discoverTab}) {
    const [stickyOffset, setStickyOffset] = useState();
    const pillsRef = useRef(null);

    useEffect(() => {
        const activePill = pillsRef.current?.querySelector('.DiscoverCategoryFilter-pill.active');

        if (activePill) {
            activePill.scrollIntoView({
                behavior: 'auto',
                inline: 'center',
                block: 'nearest',
            });
        }
    }, [selectedCategory.name]);

    useEffect(() => {
        const navElement = document.querySelector('.Navigation-nav');
        const submenuElement = document.querySelector('.Navigation-submenu');

        if (!navElement) {
            return undefined;
        }

        const updateStickyOffset = () => {
            const navBottom = navElement.getBoundingClientRect().bottom;
            const submenuVisible = submenuElement &&
                window.getComputedStyle(submenuElement).display !== 'none';
            const submenuHeight = submenuVisible ? submenuElement.getBoundingClientRect().height : 0;
            setStickyOffset(navBottom + submenuHeight);
        };

        updateStickyOffset();

        let resizeObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(updateStickyOffset);
            resizeObserver.observe(navElement);
            if (submenuElement) {
                resizeObserver.observe(submenuElement);
            }
        } else {
            window.addEventListener('resize', updateStickyOffset);
        }

        return () => {
            if (resizeObserver) {
                resizeObserver.disconnect();
            } else {
                window.removeEventListener('resize', updateStickyOffset);
            }
        };
    }, []);

    if (!categories) {
        return null;
    }

    return (
        <div className="DiscoverCategoryFilter"
             style={stickyOffset ? {'--discover-sticky-offset': `${stickyOffset}px`} : undefined}>
            <div className="DiscoverCategoryFilter-pills" ref={pillsRef}>
                {categories.map(category => (
                    <NavLink
                        className={`DiscoverCategoryFilter-pill ${selectedCategory.name === category.name ? 'active' : ''}`}
                        key={category.name}
                        to={discoverUrl(discoverTab, category)}
                        end={true}
                        replace={true}>
                        {category.name}
                    </NavLink>
                ))}
            </div>
        </div>
    );
}
DiscoverCategoryFilter.propTypes = {
    categories: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string.isRequired,
    })),
    selectedCategory: PropTypes.shape({
        name: PropTypes.string.isRequired,
    }).isRequired,
    discoverTab: PropTypes.symbol.isRequired,
};
